import Vue from 'vue'
import moment from 'moment'

Vue.filter('time', (_) => {
  if (_) return moment(+_).format('YYYY/MM/DD HH:mm')
  return _
})

Vue.filter('date', (_) => {
  if (_) return moment(+_).format('YYYY/MM/DD')
  return _
})
